export default "https://assets.pclncdn.com/web/next-landing/80a0a33/_next/static/images/Three-a112201b65eb30d1dfecbdd118ebcc92.svg";